import { useState, useEffect } from 'react';

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

const useForm = ({ initialValues, callback, validate, validateOnChange, }) => {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isSent, setIsSent] = useState(false);
    useEffect(() => {
        if (errors.valid && isSubmitting) {
            callback(values);
        }
        setIsSubmitting(false);
    }, [errors]);
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        if (event) {
            event.preventDefault();
        }
        setIsSubmitting(true);
        setIsSent(true);
        setErrors(yield validate(Object.assign({}, values)));
    });
    const handleChange = (fieldValue) => __awaiter(void 0, void 0, void 0, function* () {
        let name = '';
        let value = '';
        if (fieldValue.target) {
            name = fieldValue.target.name;
            value = fieldValue.target.value;
        }
        else {
            name = fieldValue.name;
            value = fieldValue.value;
        }
        setValues((prev) => (Object.assign(Object.assign({}, prev), { [name]: value })));
        if (validateOnChange && isSent) {
            const validation = yield validate(Object.assign(Object.assign({}, values), { [name]: value }));
            setErrors((prev) => (Object.assign(Object.assign(Object.assign({}, prev), validation), { validation: Object.assign(Object.assign({}, prev.validation), validation.validation) })));
        }
    });
    return {
        handleChange,
        handleSubmit,
        values,
        errors,
    };
};

export { useForm };
